import React from 'react'
import MenuPages from './MenuPages'
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const TopFooterPages = () => {

    const addPagesPermission = checkPermission(
        permissionsConfig.addTopFooterPages.role,
        permissionsConfig.addTopFooterPages.action,
        permissionsConfig.addTopFooterPages.type
    );

    const editPagesPermission = checkPermission(
        permissionsConfig.editTopFooterPages.role,
        permissionsConfig.editTopFooterPages.action,
        permissionsConfig.editTopFooterPages.type
    );
        
    const deletePagesPermission = checkPermission(
        permissionsConfig.deleteTopFooterPages.role,
        permissionsConfig.deleteTopFooterPages.action,
        permissionsConfig.deleteTopFooterPages.type
    );

    return (
        <MenuPages title="Top Footer pages" type="2" pageFrom="top-footer-pages" addPagesPermission={addPagesPermission} editPagesPermission={editPagesPermission} deletePagesPermission={deletePagesPermission}></MenuPages>
    )
}

export default TopFooterPages